import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import UserProductsServices from './user_product_services';

export const UserGetAllProduct = createAsyncThunk(
  'user_product/user_get_all_product',
  async (payload, thunkAPI) => {
    try {
      let response = await UserProductsServices.userGetAllProduct(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserGetSingleProductDetails = createAsyncThunk(
  'user_product/user_get_single_product',
  async (payload, thunkAPI) => {
    try {
      let response = await UserProductsServices.userGetSingleProductDetails(
        payload
      );

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserSearchForProductsByTitle = createAsyncThunk(
  'user_product/userSearchForProductsByTitle',
  async (payload, thunkAPI) => {
    try {
      const delivered = await UserProductsServices.UserSearchForProductByTitle(
        payload
      );

      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
